import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import AddButton from "../../../components/AddButton";
import ChatUser from "./ChatUser";
import { IUserTypes } from "../../../types/contacts";

interface DirectMessagesProps {
  title: string;
  users: IUserTypes[];
  openAddContact: () => void;
  selectedChatId: number;
  onSelectChat: (id: number) => void;
}

const DirectMessages = ({
  title,
  users,
  openAddContact,
  selectedChatId,
  onSelectChat
}: DirectMessagesProps) => {

  // console.log("render DirectMessages")

  return (
    <>
      <div className="d-flex align-items-center px-4 mt-3 mb-2">
        <div className="flex-grow-1">
          <h4 className="mb-0 font-size-14 text-muted text-uppercase">
            {title} ({users.length})
          </h4>
        </div>
        <div className="flex-shrink-0">
          <div id="new-message">
            <AddButton id="new-message" onClick={openAddContact} />
          </div>
          <UncontrolledTooltip
            target="new-message"
            placement="bottom"
            transition={{ timeout: 1 }}
            delay={0}
          >
            Nova mensagem
          </UncontrolledTooltip>
        </div>
      </div>

      <div className="chat-message-list">
        <ul className="list-unstyled chat-list chat-user-list">
          {users?.map((user) => (
            <ChatUser
              key={user.id}
              user={user}
              selectedChat={selectedChatId}
              unreadCount={user.unreadCount}   // 👈 já vem do useChats!
              onSelectChat={onSelectChat}
            />

          ))}
        </ul>
      </div>
    </>
  );
};

export default DirectMessages;
